import { MathUtils } from 'three';

// lerp between a and b over progress, where progress is clamped between 0 and 1
// Factor lets you ease-in or ease-out, must be greater than 0;
// A factor of 1 is linear, over 1 eases in, and under 1 eases out, proportional to value
export const clampedLerp = (a: number, b: number, progress: number, factor: number = 1): number => {
    if (factor <= 0) {
        throw new Error(`'factor' should be greater than 0, value was ${factor}`);
    }
    return MathUtils.lerp(a, b, MathUtils.clamp(progress, 0, 1) ** factor);
};

export const oscillate = (min: number, max: number, progress: number, period: number): number =>
    MathUtils.lerp(
        min,
        max,
        // sin oscillates between -1 and 1, so add 1 so it oscillates between 0 and 2, then divide by 2
        (Math.sin((2 * Math.PI * progress) / period) + 1) / 2
    );
